import { Injectable } from '@angular/core';
import { AccessibilityCheckModel, ResposibilityType, TagType } from '../accessibility-check-model';
import { TranslateService } from 'app/services/translate/translate.service';


export type OutputAccessibilityCheckType = AccessibilityCheckModel & {
    severityName: string;
    priorityName: string;
    tagsNames: TagType[];
    responsibilitiesNames: ResposibilityType[];
};

@Injectable({
    providedIn: 'root',
})
export class OutputAccessibilityCheckMakerService {

    constructor (
        private translateService: TranslateService,
    ) {}

    decorate (check: AccessibilityCheckModel): OutputAccessibilityCheckType {
        return Object.assign(check, {
            severityName: this.getSeverityName(check),
            priorityName: this.getPriorityName(check),
            tagsNames: this.getTagsName(check),
            responsibilitiesNames: this.getResponsibilitiesName(check),
        });
    }

    private getSeverityName (check: AccessibilityCheckModel): string {
        const severity = check.severityList.find((i) => i.value === check.severity);
        if (!severity) {
            return this.translateService.getString('No Severity level set');
        }

        return severity.name;
    }

    private getPriorityName (check: AccessibilityCheckModel): string {
        const priority = check.levelList.find(p => p.value === check.difficulty);
        if (!priority) {
            return this.translateService.getString('No difficulty set');
        }

        return priority.name;
    }

    private getTagsName (check: AccessibilityCheckModel): TagType[] {
        if (Array.isArray(check.tags)) {
            return check.tagList.filter(t => {
                return check.tags.indexOf(t.value) > -1;
            });
        }
        return [];
    }

    private getResponsibilitiesName (check: AccessibilityCheckModel): ResposibilityType[] {
        if (Array.isArray(check.responsibilities)) {
            return check.responsibilityList.filter(r => {
                return check.responsibilities.indexOf(r.value) > -1;
            });
        }
        return [];
    }
}
